import { useLayoutEffect } from "react"
import { UseFormReturn } from "react-hook-form"
import { useLens } from "@hookform/lenses"
import { QuestionnaireFormType } from "@/modules/patients/detail/progress-note/components/questionnaire"
import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { useStoreFormEffect } from "@/modules/patients/detail/progress-note/hooks/useStoreFormEffect"
import { StoreFormState } from "@/modules/patients/detail/progress-note/hooks/useStoreFormState"
import { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

export const useProgressNoteQuestionSummaryFormEffect = (
  id: string,
  episodeOfCareProgressNoteData: EpisodeOfCareProgressNoteData,
  storeFormState: StoreFormState,
  form: UseFormReturn<QuestionnaireFormType>,
) => {
  const setProgressNoteForm = useProgressNoteFormContext((state) => state.setProgressNoteForm)

  const lens = useLens({ control: form.control })

  useStoreFormEffect(storeFormState, form, lens.focus("formIsDirty"))

  useLayoutEffect(() => {
    setProgressNoteForm(id, episodeOfCareProgressNoteData, { kind: "QuestionSummary", data: form })
  }, [id, episodeOfCareProgressNoteData, form, setProgressNoteForm])
}
